"use client";

import React from "react";
import { Video, User, Languages, Users, MonitorPlay } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const eventDetails = [{
  title: "Specialist Symposium",
  description: "A comprehensive forum discussing the latest clinical advancements and dental excellence.",
  icon: Video
}, {
  title: "Board Assembly",
  description: "Regular strategic sessions held by our Board of Administrators to guide MDSA.",
  icon: User
}, {
  title: "Global Exchange",
  description: "Facilitating international collaboration and knowledge sharing among dental specialists worldwide.",
  icon: Languages
}, {
  title: "Member Network",
  description: "Exclusive networking opportunities for members to foster collaboration and professional community.",
  icon: Users
}, {
  title: "Digital Seminar",
  description: "High-definition broadcasts of surgical procedures and technological showcases for all members.",
  icon: MonitorPlay
}];
export default function WhatHappens() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const gridReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}